import toast from 'react-hot-toast';

import { toastStyles } from './toast-styles';

export const toastManager = {
    onSuccess: ({ title }: { title: string }) => {
        toast.success(title, {
            className: toastStyles.success.style,
            icon: toastStyles.success.icon,
        });
    },
    onError: ({ title, duration }: { title: string; duration?: number }) => {
        toast.error(title, {
            className: toastStyles.error.style,
            icon: toastStyles.error.icon,
            duration,
        });
    },
};
